import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiEdit, FiBarChart2, FiEye, FiMoreHorizontal, FiPlus, FiBookOpen } = FiIcons;

const ManagedMemorialsList = ({ memorials }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-serif text-2xl text-accent-navy">Your Sanctuaries</h3>
        <Link to="/create" className="text-[10px] font-black uppercase tracking-widest text-accent-gold hover:text-accent-navy transition-colors flex items-center gap-2">
          <SafeIcon icon={FiPlus} /> Create New
        </Link>
      </div>
      
      {(!memorials || memorials.length === 0) ? (
        <div className="bg-white rounded-[32px] border-2 border-dashed border-brand-dark p-12 text-center">
          <div className="w-16 h-16 bg-brand-light rounded-2xl flex items-center justify-center mx-auto mb-4 border border-brand-dark">
            <SafeIcon icon={FiBookOpen} className="w-8 h-8 text-accent-gold/40" />
          </div>
          <h4 className="text-lg font-serif text-accent-navy mb-2">No Sanctuaries Yet</h4>
          <p className="text-text-muted text-sm font-light mb-6 max-w-sm mx-auto">
            Create your first memorial page to start preserving a legacy. It only takes a few minutes.
          </p>
          <Link to="/create" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-gold text-white rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-accent-gold/90 transition-all shadow-md">
            <SafeIcon icon={FiPlus} className="w-4 h-4" /> Create First Memorial
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {memorials.map((m, idx) => (
            <motion.div
              key={m.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="bg-white p-5 rounded-3xl border border-brand-dark flex flex-col md:flex-row items-center gap-6 group hover:border-accent-gold/30 transition-all"
            >
              <div className="w-20 h-20 rounded-2xl overflow-hidden flex-shrink-0 shadow-sm">
                <img src={m.profileImage} alt="" className="w-full h-full object-cover" />
              </div>
              
              <div className="flex-grow text-center md:text-left">
                <h4 className="font-serif text-xl text-accent-navy mb-1">{m.name}</h4>
                <p className="text-xs text-text-muted font-medium mb-3 md:mb-0">Created {new Date(m.created_at || '2024-01-15').toLocaleDateString()}</p>
              </div>

              <div className="flex items-center gap-2">
                <Link to={`/dashboard/${m.id}`} className="p-3 bg-brand-light text-accent-navy rounded-xl hover:bg-accent-navy hover:text-white transition-all flex items-center gap-2 group/btn">
                  <SafeIcon icon={FiBarChart2} className="w-4 h-4" />
                  <span className="text-[10px] font-black uppercase tracking-widest hidden lg:inline">Analytics</span>
                </Link>
                <Link to={`/memorial/${m.id}`} className="p-3 bg-brand-light text-accent-navy rounded-xl hover:bg-accent-gold hover:text-white transition-all flex items-center gap-2 group/btn">
                  <SafeIcon icon={FiEye} className="w-4 h-4" />
                  <span className="text-[10px] font-black uppercase tracking-widest hidden lg:inline">View</span>
                </Link>
                <button className="p-3 text-text-muted hover:bg-brand-light rounded-xl transition-colors">
                  <SafeIcon icon={FiMoreHorizontal} className="w-5 h-5" />
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ManagedMemorialsList;